import { Text } from "@/ui";
import { t } from "@/utils";
import Time from "@/lib/Time";
import { textOverflowDots } from "@/theme/utils/style";
import { getHasActiveSubscription } from "@/store/auth/selectors";
import { useAuth } from "@/store/auth";

const ONE_DAY_IN_MS = 86400000;

type EventStringKey =
  | (typeof stringKeys)["MOTION"]["active"]
  | (typeof stringKeys)["MOTION"]["finished"]
  | (typeof stringKeys)["NOISE"]["active"]
  | (typeof stringKeys)["NOISE"]["finished"];

const stringKeys = {
  MOTION: {
    active: "motionDetection.now",
    finished: "monitor.lastMotion"
  },
  NOISE: {
    active: "noiseDetection.now",
    finished: "parentStation.monitor.lastNoise"
  }
} as const;

export default function LastActivity({ preview }: { preview: CameraPreviewState[string] }) {
  const isPremium = useAuth(getHasActiveSubscription);
  const event = preview?.status?.lastEvent;
  let stringKey: EventStringKey | "noEventsRecently" = "noEventsRecently";
  if (event?.type === "MOTION" && !event.finished) stringKey = stringKeys["MOTION"].active;
  else if (event?.type === "NOISE" && !event.finished) stringKey = stringKeys["NOISE"].active;
  else if (event && event.finished) {
    const activitylogSaveDuration = isPremium ? 21 * ONE_DAY_IN_MS : ONE_DAY_IN_MS;
    const isEventInActivityLog = Date.now() - event.end < activitylogSaveDuration;
    if (isEventInActivityLog) stringKey = stringKeys[event.type as Exclude<RepeatedTimeEvent, "MANUAL_VIDEO">].finished;
  }

  return (
    <Text {...textOverflowDots} fontSize="0.75rem" lineHeight="16px" letterSpacing="0.4px">
      {t(stringKey, {
        0: Time.fromNow(event?.end || 0)
      })}
    </Text>
  );
}
